interface Tab {
  id: string;
  label: string;
  idx?: number;
  count?: number;
}

interface SectionTabsProps {
  value: string;
  onChange: (id: string) => void;
  tabs: Tab[];
}

export function SectionTabs({ value, onChange, tabs }: SectionTabsProps) {
  return (
    <div
      role="tablist"
      style={{
        display: 'flex',
        gap: 0,
        borderBottom: '1px solid var(--bx-border-muted)',
      }}
    >
      {tabs.map((t) => {
        const active = t.id === value;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              position: 'relative',
              padding: '10px 14px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              color: active ? 'var(--bx-primary)' : 'var(--bx-text-body)',
              fontWeight: active ? 600 : 500,
              fontSize: 13,
              fontFamily: 'var(--bx-font-sans)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: -1,
            }}
          >
            {t.idx !== undefined && (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 18,
                  height: 18,
                  borderRadius: 9999,
                  background: active ? 'var(--bx-primary)' : 'var(--bx-surface-2)',
                  color: active ? '#fff' : 'var(--bx-text-muted)',
                  fontSize: 10,
                  fontWeight: 700,
                }}
              >
                {t.idx}
              </span>
            )}
            <span>{t.label}</span>
            {t.count !== undefined && (
              <span
                style={{
                  fontSize: 11,
                  color: 'var(--bx-text-muted)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {t.count}
              </span>
            )}
            {active && (
              <span
                style={{
                  position: 'absolute',
                  bottom: -1,
                  left: 8,
                  right: 8,
                  height: 2,
                  background: 'var(--bx-primary)',
                  borderRadius: 2,
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
